export default __webpack_public_path__ + "static/media/arrow_left-white.5b45e566.svg";